import { useEffect } from 'react'

import { useNavigate, useSearchParams } from 'react-router-dom'

import { REDIRECT_TO_STORAGE_KEY } from 'auth/domain/User'
import useOauth2Flow from 'auth/ui/hooks/useOauth2'

const LoginThroughBIP = () => {
  const { logIn, isLoggedIn } = useOauth2Flow()
  const navigate = useNavigate()

  const [searchParams] = useSearchParams()

  useEffect(() => {
    async function redirect() {
      const redirectTo = searchParams.get('redirect_to')

      const isLogged = await isLoggedIn()
      if (isLogged) {
        navigate(redirectTo ?? '/demo')
        return
      }

      if (redirectTo) {
        localStorage.setItem(REDIRECT_TO_STORAGE_KEY, redirectTo)
      }

      logIn()
    }

    redirect()
  }, [])

  return null
}

export default LoginThroughBIP
